let memoizedColumns = []
const FollowupStatusColumn = () => {
    if (memoizedColumns.length > 0) {
        return memoizedColumns
    }
    memoizedColumns = [
        {
            accessorKey: 'checkbox',
            header: '',
        },
        {
            accessorKey: 'followup_status',
            header: 'Followup Status',
        },
       
    ]
    return memoizedColumns
}
export default FollowupStatusColumn